import { API_BASE_URL } from './apiBase';

export const normalizeImagePath = (value) => {
  if (!value) return '';
  if (typeof value === 'string') return value;
  if (typeof value === 'object') {
    return value.path || value.image_path || value.imagePath || '';
  }
  return '';
};

export const resolveMediaUrl = (path) => {
  const normalized = normalizeImagePath(path);
  if (!normalized) return '';
  if (normalized.startsWith('http')) return normalized;
  if (normalized.startsWith('/uploads')) {
    const origin = API_BASE_URL.replace(/\/api\/?$/, '');
    return `${origin}${normalized}`;
  }
  return normalized;
};

/** Miniatura para tarjetas del listado (si existe). Fallback = original. */
const ORIGINAL_CARD_IMAGE_NAMES = new Set(
  [
    'click',
    'abuela',
    'bakhita',
    'kasia',
    'amitha con brazos',
    'iris',
    'profile 1 plaza',
    'profile dos plazas',
    'profile tres plazas',
    'sofa profile una plaza',
    'sofa profile dos plazas',
    'sofa profile tres plazas',
    'sofa profile 1 plaza',
  ].map((name) => name.toLowerCase())
);

const ORIGINAL_CARD_CATEGORY_SLUGS = new Set([
  'estaciones-de-trabajo',
  'mesas-de-trabajo',
]);

const normalizeCardKey = (value) =>
  String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();

export const shouldUseOriginalProductCardImage = (product) => {
  if (!product) return false;

  const categorySlug = String(product.category_slug || '').toLowerCase();
  if (ORIGINAL_CARD_CATEGORY_SLUGS.has(categorySlug)) return true;

  const categoryName = normalizeCardKey(product.category);
  if (
    categoryName === 'estaciones de trabajo' ||
    categoryName === 'mesas de trabajo'
  ) {
    return true;
  }

  const name = normalizeCardKey(product.name);
  if (ORIGINAL_CARD_IMAGE_NAMES.has(name)) return true;

  // Por si el nombre viene con prefijo "Sofá Profile..."
  if (name.includes('profile') && name.includes('plaza')) return true;

  return false;
};

export const resolveProductCardImage = (path, product) => {
  if (shouldUseOriginalProductCardImage(product)) {
    return resolveMediaUrl(path);
  }

  const normalized = normalizeImagePath(path);
  if (!normalized) return '';
  if (!normalized.startsWith('/uploads/products/')) {
    return resolveMediaUrl(normalized);
  }

  const filename = normalized.split('/').pop() || '';
  const base = filename.replace(/\.[^.]+$/, '');
  if (!base) return resolveMediaUrl(normalized);

  const thumbPath = `/uploads/products/thumbs/${base}.jpg`;

  // En local, CRA sirve public/ directo (más fiel para probar thumbs).
  if (
    typeof window !== 'undefined' &&
    /localhost|127\.0\.0\.1/.test(window.location.hostname)
  ) {
    return thumbPath;
  }

  return resolveMediaUrl(thumbPath);
};

const handleJsonResponse = async (response) => {
  if (!response.ok) {
    throw new Error(`API request failed with status ${response.status}`);
  }
  return response.json();
};

export const getCategories = async () => {
  const response = await fetch(`${API_BASE_URL}/categories`);
  return handleJsonResponse(response);
};

export const getProducts = async () => {
  const response = await fetch(`${API_BASE_URL}/products`);
  return handleJsonResponse(response);
};

export const getProductBySlug = async (slug) => {
  const response = await fetch(
    `${API_BASE_URL}/products/${encodeURIComponent(slug)}`
  );
  return handleJsonResponse(response);
};
